/* eslint-disable react/prop-types */
import React, { useState } from 'react';

const initialContext = {
    config: {},
//    price_list: '',
    legal_url: '',
    model_url: '',
    available_cars: [],
    available_extras: [],
    selected_car: null,
    selected_extras: [],
    delivery: {
        method: null,
        subMethod: null,
        distance: null
    },
    unit_options: [
        {label: 'Días', value: 'dias'},
        {label: 'Horas', value: 'horas'},
    ],
    unit: 'dias',
    amount: 0,
    social_media: null,
    discounts: [],
    selected_discount: 0
}

const CotizadorContext = React.createContext([{}, () => {}])

const CotizadorProvider = props => {
    const [state, setState] = useState(initialContext)
    return <CotizadorContext.Provider value={[state, setState]}>{props.children}</CotizadorContext.Provider>
}

export {CotizadorContext, CotizadorProvider, initialContext}